/* ==========================================================
   CRO - "Yape, Plin y PagoEfectivo estan dentro de Mercado Pago".
   set. 2026

   QUE PROBLEMA RESUELVE.
   Medido leyendo el checkout en vivo: la palabra "Yape" NO APARECE NI UNA
   VEZ en toda la pantalla de pago. Los metodos se llaman "Tarjeta de
   credito", "Mercado Pago" y "Deposito Bancario", a secas.

   Y peor, medido en celular (375x812):
       encabezado "Pago" ..... y=1151
       Tarjeta de credito .... y=1246
       Mercado Pago .......... y=1788
   El formulario de tarjeta ocupa 542px en el medio. Hay que scrollear
   1016px para descubrir que Mercado Pago existe. Reordenar los metodos
   necesita personalizaciones de pago, que son de Shopify Plus; la tienda
   es Basic. Por eso el aviso va en el carrito, la pantalla anterior.

   LO QUE SI EXISTE Y NADIE VE.
   Mercado Pago declara siete metodos. El checkout muestra tres iconos
   -mercadopago, visa, master- y esconde los otros cuatro detras de un
   "+4" que nadie toca. Detras del +4 estan, con estos nombres exactos:
       visa, master, diners club, american express, YAPE, PAGOEFECTIVO
   O sea que el logo de Yape ya esta en el checkout. Enterrado.

   ERROR YA COMETIDO: en una primera lectura del checkout se concluyo que
   ningun metodo tenia iconos, y sobre eso se dijo que PagoEfectivo no
   estaba confirmado. Era falso: los iconos si estaban, la consulta se hizo
   antes de que cargaran. Cuando algo se mide y sale vacio, conviene
   repetir la medicion antes de sacar conclusiones.

   SOBRE PLIN.
   Mercado Pago NO lo declara en esa lista. El cliente confirma que Yape y
   Plin funcionan igual en su flujo y pidio nombrarlo. Queda escrito, y
   queda anotado aca que es el unico de los tres sin respaldo en la
   declaracion de la pasarela.

   POR QUE ESTO NO SE ARREGLA EN EL CHECKOUT MISMO.
   El nombre y los iconos de un metodo los declara la pasarela. Se buscaron
   las 4480 cadenas del checkout: Shopify tiene clave de etiqueta para
   paypal, klarna, oxxo, alipay, bizum y una veintena mas, pero NO para
   Mercado Pago, porque es una app. Lo unico editable ahi son dos textos
   sueltos, que se cambiaron en locales/es.json (shopify.checkout.payment).
   Esta tira del carrito es el refuerzo, en la pantalla anterior.

   DONDE SE INSERTA Y CUANTO CUESTA.
   Arriba de la caja de cupon, o sea en el borde superior del bloque gris.
   NO entre el subtotal y el boton: esa zona quedo despejada a proposito y
   no se vuelve a llenar.
   Costaba 58px de alto. Con los logos en linea bajo a ~36px. El detalle
   de esa medicion esta en gs-carrito-pagos.css.
   ========================================================== */

(function () {

  // Los mismos contenedores que usa gs-carrito-pie.js: el cajon lateral y
  // la columna derecha de /cart. Si cambia uno, cambiar en los dos.
  var ZONAS = ['.cart-drawer__footer', '.checkout-subtotal-container__right'];

  var CDN = 'https://cdn.shopify.com/s/files/1/0608/3824/8537/files/';

  // LOS LOGOS VAN DENTRO DEL <p>, NO EN UNA FILA APARTE. Una fila propia
  // costaba 24px (18 de alto + 6 de hueco) para no agregar informacion:
  // los mismos logos, en el mismo orden, un renglon mas abajo. En linea
  // viajan al final del texto y el bloque baja de 58 a ~36px.
  //
  // Las marcas van en <strong> porque aca SI se controla el marcado. En la
  // pantalla de pago la misma frase sale plana: Shopify solo interpreta
  // formato en claves terminadas en _html y card_security_notice no tiene.
  //
  // Hay tres logos y el texto nombra cuatro cosas: no existe archivo de
  // PagoEfectivo en la biblioteca. Los logos ilustran, el texto informa.
  //
  // width y height van explicitos para que el navegador reserve el hueco y
  // el pie no salte cuando cargan. Salen del archivo original escalado a
  // 16px de alto: yape 303x160, plin 160x160, mercado pago 176x114.
  var HTML =
    '<div class="gs-pagos">' +
      '<p class="gs-pagos__texto">' +
        'Elige Mercado Pago para pagar con <strong>Yape, Plin o PagoEfectivo</strong>' +
        '<span class="gs-pagos__logos">' +
          '<img src="' + CDN + 'yape-badge.png?v=1784766624" alt="Yape" width="30" height="16" loading="lazy">' +
          '<img src="' + CDN + 'plin-badge.png?v=1784766624" alt="Plin" width="16" height="16" loading="lazy">' +
          '<img src="' + CDN + 'mercado-pago-badge.png?v=1788908315" alt="Mercado Pago" width="25" height="16" loading="lazy">' +
        '</span>' +
      '</p>' +
    '</div>';

  function montar() {
    ZONAS.forEach(function (sel) {
      var raiz = document.querySelector(sel);
      if (!raiz || raiz.querySelector('.gs-pagos')) return;

      // Va pegado ARRIBA del cupon. Si el cupon todavia no se inyecto -lo
      // hace gs-carrito-pie.js- no se hace nada y se reintenta en el
      // proximo evento del carrito: asi el orden queda siempre
      //   pagos -> cupon -> subtotal -> boton -> seguir comprando
      var cupon = raiz.querySelector('.gs-cupon');
      if (!cupon) return;
      cupon.insertAdjacentHTML('beforebegin', HTML);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }

  // El pie es data-merge-attributes, o sea que su contenido sobrevive a las
  // actualizaciones del carrito y esto se inserta una sola vez. Se escucha
  // igual porque en la primera carga el cupon puede no existir todavia.
  ['on:cart:add', 'on:cart:change', 'on:line-item:change', 'on:cart-drawer:after-open']
    .forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(montar, 60); });
    });
})();
